import { setterAction, createAction } from "../common/redux"
import * as t from "./actionTypes"
import * as generator from "../chatItemGenerator"
import Source from "./Source"
import interviewSource from "../interview/Source"
import { coronavirusSearch } from "../integration/utils"
import { captureException } from "../common/error"
import { addChatItem, addChatItems, setLoading } from "../interview/actions"
import { submitClarifier, setItemFinished } from "../search/actions"
import {
  interviewQuestion,
  response,
  identityQues,
  systemMessage,
  temporaryMessage,
} from "../chatItemGenerator"
import { setDiagnosisConcern } from "../feedback/actions"
import { displayTermsWall } from "../identifiers/actions"
import { messages } from "../chatItemGenerator"

export const setSimpleFlowDiagnosis = setterAction(t.SET_SIMPLE_FLOW_DIAGNOSIS)
export const setCardinalResponses = setterAction(t.SET_CARDINAL_RESPONSES)
export const setCardinalEvidence = setterAction(t.SET_CARDINAL_EVIDENCE)
export const setSimpleFlowActive = setterAction(t.SET_SIMPLE_FLOW_ACTIVE)
export const setCardinalSubmitted = setterAction(t.SET_CARDINAL_SUBMITTED)
export const shiftCardinalResponses = createAction(t.SHIFT_CARDINAL_RESPONSES)

export const initSimpleFlow = diagnosis => dispatch => {
  // TODO: CORONAVIRUS TECH DEBT, remove this if statement and replace with the else when
  dispatch(setSimpleFlowActive(true))
  if (coronavirusSearch(diagnosis)) {
    dispatch(setSimpleFlowDiagnosis("coronavirus"))
  } else {
    dispatch(setSimpleFlowDiagnosis(diagnosis))
  }
}

export const askCardinal = () => dispatch => {
  const coronaToken = "39651"
  Source.getCardinalSymptoms(coronaToken)
    .then(data => {
      dispatch(
        addChatItem(covertToCardinalQuestion(interviewQuestion(data.qdata)))
      )
    })
    .catch(captureException)
}

// submit cardinal evidence after close input (all the filters are submitted)
export const submitCardinalEvidence = () => (dispatch, getState) => {
  const { simpleFlow } = getState()
  const { cardinalEvidence = [] } = simpleFlow

  const optionTokens = cardinalEvidence.options
    .filter(symptom => !symptom.isnota)
    .map(symptom => symptom.token)
  const responseTokens = cardinalEvidence.response.map(symptom => symptom.token)

  let evidence = optionTokens.reduce((accObj, token) => {
    const result = responseTokens.includes(token)
    accObj[token] = result
    return accObj
  }, {})

  const notaToken = cardinalEvidence.options
    .filter(symptom => symptom.isnota)
    .map(symptom => symptom.token)
  // bit of a hacky way to submit NOTA evidence but it
  // works for now without breaking other functionality
  evidence[notaToken] = responseTokens.length === 0

  return Source.submitCardinalEvidence(evidence).catch(captureException)
}

export const submitDiagnosisConcern = () => (dispatch, getState) => {
  let { simpleFlow } = getState()
  const { diagnosis } = simpleFlow

  interviewSource
    .getDiagnosisContentPage(diagnosis)
    .then(payload => {
      let contentPage = ""
      if (payload.content.toString()) {
        contentPage = payload.content[0].url
      }
      dispatch(
        setDiagnosisConcern({
          display: diagnosis,
          contentPage,
        })
      )
    })
    .catch(e => {
      captureException(e)
      dispatch(
        setDiagnosisConcern({
          display: diagnosis,
          contentPage: "",
        })
      )
    })

  return interviewSource
    .submitDiagnosisConcern(diagnosis, true)
    .catch(captureException)
}

export const newVisitActions = () => dispatch => {
  return Promise.all([
    dispatch(submitCardinalEvidence()),
    dispatch(submitDiagnosisConcern()),
  ])
}

export const cardinalQuestionSubmit = (isNota = false) => (
  dispatch,
  getState
) => {
  const { chatList } = getState()
  const activeItem = chatList.items[chatList.active]

  dispatch(
    setCardinalEvidence({
      response: activeItem.response,
      options: activeItem.options,
    })
  )

  if (!isNota) {
    dispatch(setCardinalResponses(activeItem.response))
  }
  dispatch(setCardinalSubmitted(true))

  // display terms and conditions or proceed to next question
  if (!dispatch(displayTermsWall(afterCardinalQuestionSubmit, isNota))) {
    dispatch(afterCardinalQuestionSubmit(isNota))
  }
}

const afterCardinalQuestionSubmit = isNota => (dispatch, getState) => {
  const { auth, account, chatList } = getState()
  const activeItem = chatList.items[chatList.active]

  let responseText, transitionText1, transitionText2
  if (isNota) {
    dispatch(setSimpleFlowActive(false))
    responseText = messages.preintentOptionNota
    transitionText1 = `Good to know. While those are the most common
      symptoms associated with coronavirus, there are others to consider, too.`
    transitionText2 = messages.interviewMessagesCoronaIdentifiers
  } else {
    responseText = activeItem.response
      .filter(r => !r.preselected)
      .map(r => r.freetext || r.text)
      .join(", ")
    transitionText1 = messages.interviewMessagesCoronaSymptoms
    transitionText2 = messages.interviewMessagesCoronaIdentifiers
  }

  dispatch(
    addChatItems([
      response(responseText),
      systemMessage(transitionText1),
      systemMessage(transitionText2),
      identityQues(account.profiles, auth.isAnonymous),
    ])
  )
}

const covertToCardinalQuestion = question => {
  return Object.assign(question, { type: "cardinalQuestion" })
}

export const addCardinalResponseFilter = () => (dispatch, getState) => {
  const { simpleFlow } = getState()
  const { cardinalResponses } = simpleFlow

  const thisResponse = cardinalResponses[0]

  // TODO: FORMAT THIS FOR TRANLATION
  // const thisMessage =
  //   thisResponse.group === 0
  //     ? messages.interviewMessageFilter
  //     : messages.interviewMessageFilterNext

  //   thisResponse.group === 0 ? thisMessage.text

  const thisMessage =
    thisResponse.group === 0
      ? [
          messages.interviewMessageFilter,
          { symptom: thisResponse.text.toLowerCase() },
        ]
      : messages.interviewMessageFilterNext

  if (thisResponse.group === 0) {
    dispatch(addChatItem(systemMessage(thisMessage)))
  } else if (thisResponse.group <= 1) {
    dispatch(addChatItem(temporaryMessage(thisMessage)))
  }

  dispatch(setLoading(true))

  dispatch(addChatItem(generator.symptomBubble(true)))

  dispatch(
    submitClarifier(
      `${thisResponse.token}-${thisResponse.group}`,
      thisResponse.text
    )
  )

  dispatch(shiftCardinalResponses())
}

export const submitPresentations = () => (dispatch, getState) => {
  const { simpleFlow, identifiers, chatList } = getState()
  const { items } = chatList
  const { cardinalResponses } = simpleFlow
  let { pov } = identifiers

  const tempIndexes = items
    .filter(item => item.type === "temporaryMessage")
    .map(item => item.index)

  if (cardinalResponses.length > 0) {
    dispatch(addCardinalResponseFilter())
  } else {
    tempIndexes.forEach(index => {
      dispatch(setItemFinished(true, index))
    })
    dispatch(addChatItem(generator.intentSeekingCare(pov)))
  }
}



// WEBPACK FOOTER //
// ./assets/simpleFlow/actions.js